/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestanswerfailed2Inputs */

const en_requestanswerfailed2 = /** @type {(inputs: Requestanswerfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That did not work`)
};

const de_requestanswerfailed2 = /** @type {(inputs: Requestanswerfailed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hat nicht geklappt`)
};

/**
* | output |
* | --- |
* | "That did not work" |
*
* @param {Requestanswerfailed2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestanswerfailed2 = /** @type {((inputs?: Requestanswerfailed2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestanswerfailed2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestanswerfailed2(inputs)
	return de_requestanswerfailed2(inputs)
});
export { requestanswerfailed2 as "requestAnswerFailed" }